"use strict";

let ToggleVisibility = {
    options: {
        selector: ".toggle-visibility",
        toggleCssClass: "is-hidden",
        togglerIconOn: "fa-solid fa-angle-down",
        togglerIconOff: "fa-solid fa-angle-up",
        togglerIconSelector: ".icon i",
        rememberState: true,
    },
    state: {},
};

ToggleVisibility.init = function (userOptions) {
    for (let prop in userOptions) {
        if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
            this.options[prop] = userOptions[prop];
        }
    }

    this.initSelectors(document);
}

ToggleVisibility.initSelectors = function (rootElement) {
    let togglerElements = rootElement.querySelectorAll(this.options.selector);

    const self = this;
    togglerElements.forEach(function (togglerElement) {
        if (togglerElement.hasOwnProperty('moduleToggleVisibilityInitialized')) { return; }
        togglerElement.moduleToggleVisibilityInitialized = true;

        const target = togglerElement.dataset.target;
        const targetElement = rootElement.querySelector(target);
        const togglerIconElement = togglerElement.querySelector(self.options.togglerIconSelector);
        if (targetElement === null || targetElement === undefined) { return; }
        if (self.options.rememberState) {
            if (self.state.hasOwnProperty(target)){
                if (self.state[target]) {
                    targetElement.classList.add(self.options.toggleCssClass);
                    togglerIconElement.setAttribute("class", self.options.togglerIconOn);
                } else {
                    targetElement.classList.remove(self.options.toggleCssClass);
                    togglerIconElement.setAttribute("class", self.options.togglerIconOff);
                }
            }
        }

        togglerElement.addEventListener("click", function (event) {
            const resultState = targetElement.classList.toggle(self.options.toggleCssClass);
            if (resultState) {
                togglerIconElement.setAttribute("class", self.options.togglerIconOn);
            }else{
                togglerIconElement.setAttribute("class", self.options.togglerIconOff);
            }
            if (self.options.rememberState) {
                self.state[target] = resultState;
            }
        });
    });
}

export {ToggleVisibility};